var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPicture = function SvgIconPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M15.5 8.1a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M17 3.6H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1M6.9 7.807l-3.4 3.4V5.1h13v10h-.893L8.314 7.807a1 1 0 0 0-1.415 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconPicture;